import { CompletedCollectible, DraftCollectible } from "@/types/collectibles"
import * as Amplitude from "@amplitude/analytics-browser"

/**
 * User subscribed to suggested publication.
 */
export function subscribedToSuggestedPublication(blogId: string) {
  return Amplitude.track("subscribed_to_suggested_publication", {
    blog_id: blogId,
  })
}

/**
 * User scrolled and loaded more.
 */
export function loadedMoreFeed(type: string, page?: number, userId?: string) {
  return Amplitude.track("more_feed_loaded", { user_id: userId, page, type })
}

/**
 * User opened post collect modal.
 */
export function postCollectModalOpened(postId: string) {
  return Amplitude.track("post_collect_modal_opened", { post_id: postId })
}

/**
 * User clicked to collect post.
 */
export function postCollectButtonClicked(
  collectible: CompletedCollectible | DraftCollectible,
  isFirstCollect?: boolean
) {
  const collectibleMetrics = {
    chain: collectible.chain,
    cost_eth: collectible.costEth,
    created_at: collectible.createdAt,
    post_id: collectible.noteId,
    position: collectible.position,
    supply: collectible.supply,
    type: collectible.type,
    version: collectible.version,
    is_first_collect: isFirstCollect ? true : false,
  }
  return Amplitude.track("post_collect_button_clicked", collectibleMetrics)
}
